"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Scopes_1 = __importDefault(require("../entity/FacetParts/Scopes"));
const defaultValue = [
    { value: '2', count: 85 },
    { value: '1', count: 1 },
];
exports.generateScopeEntity = (jsons = defaultValue) => Scopes_1.default.fromJSON({
    buckets: jsons,
});
